export default __webpack_public_path__ + "static/media/34.07a94f07.png";